import React from "react";
import {useLocation, useParams} from "react-router-dom";
import AdvertisementsEditMs from "./AdvertisementsEditMs";
import GenericTemplate from "../../../templates/GenericTemplate";
import {parseInt} from "lodash";
import {
    APOLLO_GROUP_OPERATOR,
    APOLLO_SYSTEM_ADMIN,
    ApolloPageUsagePermission
} from "../../../atom/Apollo_Authorization";
import {ApolloBreadcrumbs2, BreadcrumbsData} from "../../../atom/Apollo_Breadcrumbs2";
import {CustomizedSnackbars} from "../../../atom/Apollo_Mesasge";
import {AdProcessType} from "./common/CommonConst";

/*
    画面名：広告作成（MS）
 */

const AdvertisementsCreateMs: React.FC = () => {

    const {
        accountid,
        platformaccountid,
    } = useParams<{ accountid: string, platformaccountid: string }>()

    const reqParams = new URLSearchParams(useLocation().search);
    const campaignId = reqParams.get("campaignId") ?? "0";
    const adGroupId = reqParams.get("adGroupId") ?? "0";
    const queryCampaignId = campaignId !== "0" ? `?campaignId=${campaignId}` : "";
    const queryAdGroupId = queryCampaignId !== "" ?
        adGroupId !== "0" ? `${queryCampaignId}&adGroupId=${adGroupId}` : `?campaignId=${campaignId}` :
        adGroupId !== "0" ? `?adGroupId=${adGroupId}` : "";

    const breadcrumbsData: BreadcrumbsData = {
        categoryId: 25,
        breadId: 2,
        queries: ["", "", "", "", queryCampaignId, queryAdGroupId],
        menu: {
            id: 2,
            accountId: platformaccountid,
            accountName: "",
        },
        campaign: null,
        adgroup: null,
        advertisement: null,
        asset: null,
    }

    return (
        <GenericTemplate title="">
            <CustomizedSnackbars/>
            <ApolloPageUsagePermission role={APOLLO_GROUP_OPERATOR} profile={APOLLO_SYSTEM_ADMIN}>
                <ApolloBreadcrumbs2 data={breadcrumbsData}/>
                <AdvertisementsEditMs
                    accountId={parseInt(accountid)}
                    platformaccountId={parseInt(platformaccountid)}
                    campaignId={parseInt(campaignId)}
                    adGroupId={parseInt(adGroupId)}
                    adId={null}
                    processType={AdProcessType.create}
                />
            </ApolloPageUsagePermission>
        </GenericTemplate>
    );
};

export default AdvertisementsCreateMs;
